import { createFileRoute } from "@tanstack/react-router";
import InstallApp from "@/pages/InstallApp";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/install/")({
  head: () => routeHead("/install/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <InstallApp />
  );
}
